var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "mt" },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("payment")))]),
      _vm.hasAccessToMollie
        ? [
            _c(
              "w-card-content",
              [
                _c(
                  "w-row",
                  [
                    _c(
                      "w-col",
                      { attrs: { xs: "12" } },
                      [
                        !_vm.mollieSettings.ConnectedWithMollie
                          ? _c(
                              "w-button",
                              {
                                staticClass: "mollie-connect-button",
                                on: {
                                  click: function ($event) {
                                    return _vm.connectWithMollie()
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/img/mollie-m.svg"),
                                    alt: "mollie logo letter m",
                                  },
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$ct("connect-with-mollie")) +
                                    " "
                                ),
                              ]
                            )
                          : _c(
                              "w-button",
                              {
                                staticClass: "mollie-connect-button danger",
                                on: {
                                  click: function ($event) {
                                    return _vm.disconnectFromMollie()
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/img/mollie-m.svg"),
                                    alt: "mollie logo letter m",
                                  },
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$ct("disconnect-from-mollie")) +
                                    " "
                                ),
                              ]
                            ),
                      ],
                      1
                    ),
                    _vm.mollieSettings.ConnectedWithMollie
                      ? _c(
                          "w-col",
                          { attrs: { xs: "12" } },
                          [
                            _c("w-select", {
                              attrs: {
                                items: _vm.mollieProfileItems,
                                label: _vm.$ct("mollie-profile"),
                                fancy: "",
                              },
                              model: {
                                value: _vm.mollieSettings.ProfileID,
                                callback: function ($$v) {
                                  _vm.$set(_vm.mollieSettings, "ProfileID", $$v)
                                },
                                expression: "mollieSettings.ProfileID",
                              },
                            }),
                            _c(
                              "w-link",
                              {
                                on: {
                                  click: function ($event) {
                                    _vm.createProfileModal = true
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$ct("create-mollie-profile")) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "w-col",
                      { attrs: { xs: "12" } },
                      [
                        _c("app-select-bank", {
                          attrs: {
                            "use-ids": "",
                            fancy: "",
                            label: _vm.$ct("mollie-bank"),
                          },
                          model: {
                            value: _vm.mollieSettings.BankID,
                            callback: function ($$v) {
                              _vm.$set(_vm.mollieSettings, "BankID", $$v)
                            },
                            expression: "mollieSettings.BankID",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "w-card-actions",
              [
                _c("w-spacer"),
                _c(
                  "w-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.save()
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$ct("common.save")) + " ")]
                ),
              ],
              1
            ),
          ]
        : _c("app-missing-module", {
            staticClass: "missing-mollie-module",
            attrs: { "module-id": _vm.mollieModuleID },
          }),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.createProfileModal,
            callback: function ($$v) {
              _vm.createProfileModal = $$v
            },
            expression: "createProfileModal",
          },
        },
        [
          _vm.createProfileModal
            ? _c("app-mollie-create-profile", {
                on: {
                  cancel: function ($event) {
                    _vm.createProfileModal = false
                  },
                  value: function ($event) {
                    return _vm.onProfileCreated($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }